import { InfoAlert } from 'components/alert/InfoAlert';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';
import * as React from 'react';

function Bold(chunks: React.ReactNode) {
  return <strong>{chunks}</strong>;
}

export function TradingMessagesInfoContent() {
  return (
    <div>
      <InfoAlert messageId="trading.info.alert" values={{ disclaimer: 'Disclaimer:', b: Bold }} />

      <InfoContentItem
        titleId="steeringhub.insightsfeed.info.price_analyser.title"
        descriptionId="steeringhub.insightsfeed.info.price_analyser.description"
      />

      <InfoContentItem
        titleId="steeringhub.insightsfeed.info.gmv_analyser.title"
        descriptionId="steeringhub.insightsfeed.info.gmv_analyser.description"
      />
    </div>
  );
}
